
import Styles from './MarkedContent.module.scss'
import 'highlight.js/styles/github.css';

// Module Imports
import { marked } from 'marked';
import { markedHighlight } from 'marked-highlight';
import hljs from 'highlight.js';
import DOMPurify from 'dompurify';

marked.use(
    markedHighlight({
        langPrefix: 'hljs language-', 
        highlight(code, lang) {
            const language = hljs.getLanguage(lang) ? lang : 'plaintext';
            return hljs.highlight(code, { language }).value;
        },
    })
);

marked.setOptions({
    async: false,
    gfm: true,
});

const MarkedContent = ({ content }) => {
    if (!content) content = 'No content to display';

    const getMarkdownText = () => {
        const rawHTML = marked.parse(content.replace(/^[\u200B\u200C\u200D\u200E\u200F\uFEFF]/, ''));

        const htmlWithTargetBlank = rawHTML.replace(
            /<a\s+href="(.*?)">/g,
            '<a href="$1" target="_blank" rel="noopener noreferrer">'
        );

        return {
            __html: DOMPurify.sanitize(htmlWithTargetBlank, {
                ADD_ATTR: ['target', 'rel'],
            }),
        };
    };

    return (
        <div className={Styles.reportContentContainer }>
            <div className={Styles.reportContent} dangerouslySetInnerHTML={getMarkdownText()} />
        </div>
    );
};

export default MarkedContent;